export enum PADDING_TYPE {
  none = '',
  half = 'py-20 md:py-16 sm:py-16',
  full = 'py-28 md:py-16 sm:py-14',
}

interface GREY_SECTION_PROPS {
  children: React.ReactNode;
  padding?: PADDING_TYPE;
  isGrey?: boolean;
  containerClass?: boolean;
}

export const GreySection = ({
  children,
  padding = PADDING_TYPE.half,
  isGrey = true,
  containerClass = true,
}: GREY_SECTION_PROPS): JSX.Element => {
  return (
    <div className={`${isGrey ? 'bg-grey-190' : ''} ${padding}`}>
      <div className={`${containerClass ? 'wg-container' : ''}`}>
        {children}
      </div>
    </div>
  );
};
